import React from "react";
import { Button, Icon } from "aible";

import styles from "./style.module.css";

export default class TileIcon extends React.PureComponent {
  render() {
    const { icon, size, className, retProps } = this.props;
    if (!icon) {
      return <React.Fragment />;
    }

    return (
      <div className={styles.tileIconWrapper + " " + (className ? className : "")} {...retProps}>
        {typeof icon === "string" ? <Icon type={icon} size={size || 20} /> : icon}
      </div>
    );
  }
}
